// Türkçe karakterleri doğru şekilde büyük harfe çeviren fonksiyon
export const toTurkishUpperCase = (str) => {
  if (!str) return '';
  
  const turkishCharMap = {
    'ı': 'I',
    'i': 'İ',
    'ş': 'Ş',
    'ç': 'Ç',
    'ğ': 'Ğ',
    'ü': 'Ü',
    'ö': 'Ö'
  };
  
  return str.split('').map(char => {
    return turkishCharMap[char] || char.toUpperCase();
  }).join('');
};

// Türkçe karakterleri doğru şekilde küçük harfe çeviren fonksiyon
export const toTurkishLowerCase = (str) => {
  if (!str) return '';
  
  const turkishCharMap = {
    'I': 'ı',
    'İ': 'i',
    'Ş': 'ş',
    'Ç': 'ç',
    'Ğ': 'ğ',
    'Ü': 'ü',
    'Ö': 'ö'
  };
  
  return str.split('').map(char => {
    return turkishCharMap[char] || char.toLowerCase();
  }).join('');
}; 